/** @format */

//import components
import HeadTitle from "../../components/global/HeadTitle";

//import table data
import { useDispatch, useSelector } from "react-redux";
import ShowDetailsExpense from "../../components/pops/expense/ShowDetailsExpense";
import Table from "../../components/Table2";
import { tableBanners } from "../../constant/table";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";
import { useEffect, useState } from "react";
import { Spinner1 } from "../../components/spinners/Spinner1";
import Pagination from "../../components/Pagination";
import FilterComponent from "../../components/FilterComponent";
import BannerPopUp from "./form";
import { getAllBannars } from "../../store/banners";

const Banners = () => {
  const dispatch = useDispatch();
  const banners = useSelector((state) => state.banners);
  const render = useSelector((state) => state.toggleState.value.render);
  const [isOpen, setOpen] = useState(false);
  const [isEdit, setOpenEdit] = useState(false);
  const [searchValues, setSearch] = useState({});
  const [selectedRow, setSelectedRow] = useState({});

  useEffect(() => {
    dispatch(getAllBannars("/banners"));
  }, [dispatch, render]);
  const getPageData = (num) => {
    dispatch(getAllBannars("/banners" + "?pages=" + num));
  };
  const getSearchValue = (value, labelName, stateName) => {
    let searchValuesClone = { ...searchValues };
    searchValuesClone = {
      ...searchValuesClone,
      [stateName]: { label: labelName, value: value },
    };
    setSearch(searchValuesClone);
    prepareSearchValuesForAPIs(searchValuesClone);
  };
  const deleteSearch = (stateName) => {
    let searchValuesClone = { ...searchValues };
    delete searchValuesClone[stateName];
    setSearch(searchValuesClone);
    prepareSearchValuesForAPIs(searchValuesClone);
  };
  const prepareSearchValuesForAPIs = (searchValuesClone) => {
    let searchString = "";
    Object.keys(searchValuesClone).forEach((item) => {
      searchString = searchString + item + "=" + searchValuesClone[item].value;
    });
    dispatch(getAllBannars(`/banners?${searchString}`));
  };
  return (
    <NavbarAndSidebar>
      <BannerPopUp
        isOpen={isOpen}
        isEdit={isEdit}
        setOpen={setOpen}
        toggleModal={() => setOpen(false)}
      />{" "}
      <BannerPopUp
        isOpen={isEdit}
        isEdit={isEdit}
        setOpenEdit={setOpenEdit}
        toggleModal={() => setOpenEdit(false)}
        selectedRow={selectedRow}
      />{" "}
      <ShowDetailsExpense from='cost' />
      <div className='flex-between'>
        <HeadTitle title='الاعلانات و العروض ' margin={true} />
        <button className='btn btn__primary' onClick={() => setOpen(true)}>
          اضافه اعلان او عرض{" "}
        </button>
      </div>
      <div className='mb__small' />
      {!!Object.keys(searchValues).length && (
        <FilterComponent filters={searchValues} deleteSearch={deleteSearch} />
      )}
      <Table
        data={banners?.data}
        header={tableBanners}
        link='/guarantor/'
        getSearchValue={getSearchValue}
        searchValues={searchValues}
        name='banners'
        setOpen={setOpen}
        setOpenEdit={setOpenEdit}
        setSelectedRow={setSelectedRow}
      />
      {banners?.loading && <Spinner1 />}
      {banners?.data?.pagination?.totalPages > 1 ? (
        <Pagination
          pagination={banners?.data?.pagination}
          getPageData={getPageData}
        />
      ) : null}
      {/* <DynamicTable tableColumn={tableColumnCosts} /> */}
    </NavbarAndSidebar>
  );
};
export default Banners;
